import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=443cacdc&scoped=true&"
import script from "./PoweredBy.vue?vue&type=script&lang=js&"
export * from "./PoweredBy.vue?vue&type=script&lang=js&"
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=443cacdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443cacdc",
  null
  
)

export default component.exports